export const COMMON_HEADER_TEST_IDS = {
    CART_HEADER_PARENT: `CART_HEADER_PARENT`,
    CART_HEADER: `CART_HEADER`,
    BACK_BUTTON: `BACK_BTN`,
    CLOSE_BUTTON: `CLOSE_BTN`,
    RESTAURANT_NAME: `CART_RESTAURANT_NAME`,
    RIGHT_ICON: `CART_HEADER_RIGHT_ICON`,
    DELIVERY_ADDRESS_ICON: `DELIVERY_ADDRESS_ICON`,
    ADDRESS_ANNOTATION_TEXT: `ADDRESS_ANNOTATION_TEXT`,
    DELIVERY_ADDRESS: `CART_DELIVERY_ADDRESS`,
    TOING_RTB_HEADER_LOTTIE: `toing-header-lottie`,
};
